import React from 'react'
import Link from "gatsby-link";
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import {FORM_STYLES} from '../components/assets/forms-shared'
import { colors, spacing, sizing, typography } from '../components/assets/shibui';

import SS from '../components/assets/shared-styles'
import Helmet from 'react-helmet'
import '../../src/layouts/main.css'

const S = {
  blogHeaderWrap: {
    ...SS.flexCenter,
    textAlign: 'center',
    width: '100%',
    marginTop: spacing.lg
  },
  flexContentWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 50,
  },
  postsContentWrap: {
    width: '100%',
    maxWidth: sizing.xxl,
    height: '100%',
    paddingLeft: 20,
    paddingRight: 20,
    '@media screen and (maxWidth: 1115px)': {
      width: '90%',
      paddingLeft: 10,
      paddingRight: 10
    }
  },
  flexGrid: {
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'flex-start',
    flexWrap: 'wrap',
    '@media screen and (maxWidth: 1115px)': {
      display: 'block'
    }
  },
  flexGridImage: {
    position: 'relative',
    float: 'left',
    width: '34%',
    height: '100%'
  },
  flexGridContent: {
    padding: '0px 40px 12px 40px',
    position: 'relative',
    float: 'left',
    width: '66%'
  },
  date: {
    marginTop: -spacing.sm,
    marginBottom: spacing.sm,
    fontSize: 12,
    color: colors.graphite.color
  },
  hideOnMobile: {
    '@media screen and (maxWidth: 700px)': {
      display: 'none'
    }
  },
  tag: {
    fontSize: 12,
    background: colors.amethyst50.color,
    color: colors.ivory.color,
    borderRadius: 4,
    padding: `${spacing.xs}px ${spacing.sm}px`,
    display: 'inline-block',
    marginTop: 8
  },
  ...FORM_STYLES
}

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark;
  return (
    <div>

      <Helmet>
        <title>Blog | Haiku</title>
        <meta name="description" content="Thoughts on collaboration, design, and shipping software" />
        <meta property="og:title" content="Blog | Haiku" />
        <meta property="og:description" content="Thoughts on collaboration, design, and shipping software" />
      </Helmet>

      <Navbar location="blog"/>

      <div style={{
        margin: '0 auto',
      }}>

        <div style={S.blogHeaderWrap}>
          <Link to="/blog/">
            <h1 style={{...typography.heading1, ...SS.centerer, ...{margin: `${spacing.sm}px 0 0`, color: colors.midnight.color}}}>Haiku Blog</h1>
            <p style={SS.subtitle}>Articles, videos and resources by the Haiku team.</p>
          </Link>
        </div>

        <div style={S.flexContentWrap}>
          <div style={S.postsContentWrap}>
            <div style={S.flexGrid}>
              {posts
                .filter(post => post.node.frontmatter.title.length > 0)
                .map(({ node: post }, index) => {
                  return (
                    <Link to={post.frontmatter.path} tabIndex={index + 10} className="flexGridBlog" key={post.id}>
                      <div style={S.flexGridImage}>
                        {post.frontmatter.coverImage && <img className="blogFeatureImage" src={post.frontmatter.coverImage.publicURL} alt={post.frontmatter.title}/>}
                      </div>
                      <div style={S.flexGridContent}>
                        <h3 style={{ ...typography.heading3, ...{color: colors.midnight.color}}}>{post.frontmatter.title}</h3>
                        <h4 style={S.date}>{post.frontmatter.date}</h4>
                        {post.frontmatter.tags && post.frontmatter.tags.map((tag, index) => <span key={`tag${index}`} style={S.tag}>{tag}</span>)}
                        <p style={SS.subtitle}>{post.excerpt}</p>
                      </div>
                    </Link>
                  );
                })}
            </div>

          </div>
        </div>
      </div>

    <MobileContent />

  </div>
  );
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 180)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            coverImage {
              publicURL
            }
            tags
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/blog.js